import {
    adminclubConceptsHierarchyUrl,
    adminclubQuestionOfTheDayUrl,
    adminclubTaggingTabsUrl,
} from 'mk2/apps/adminclub/urls';
import { DynamicRoute } from 'mk2/containers/Application/Application';

export const routes: DynamicRoute[] = [{
    app: 'adminclub',
    exact: true,
    path: adminclubConceptsHierarchyUrl,
    getPage: () => {
        return import('mk2/apps/adminclub/containers/ConceptsHierarchy/ConceptsHierarchyPage' /* webpackChunkName: "adminclub.ConceptsHierarchy" */);
    },
    modules: [ 'mk2/apps/adminclub/containers/ConceptsHierarchy/ConceptsHierarchyPage' ],
}, {
    app: 'adminclub',
    exact: true,
    path: adminclubTaggingTabsUrl,
    getPage: () => {
        return import('mk2/apps/adminclub/containers/TaggingTabs/TaggingTabsPage' /* webpackChunkName: "adminclub.TaggingTabs" */);
    },
    modules: [ 'mk2/apps/adminclub/containers/TaggingTabs/TaggingTabsPage' ],
}, {
    app: 'adminclub',
    exact: true,
    path: adminclubQuestionOfTheDayUrl,
    getPage: () => {
        return import('mk2/apps/adminclub/containers/AdminclubQuestionOfTheDay/AdminclubQuestionOfTheDayPage' /* webpackChunkName: "adminclub.AdminclubQuestionOfTheDay" */);
    },
    modules: [ 'mk2/apps/adminclub/containers/AdminclubQuestionOfTheDay/AdminclubQuestionOfTheDayPage' ],
}];
